import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center gap-3 py-2" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-gray-400"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 2,
  class: "text-sm text-red-400"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-400 text-center max-w-[300px]" }, " Le chauffeur scanne ce code avec l'application mobile. Le suivi GPS démarre seul et le véhicule apparaît sur la carte flotte. ", -1)
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 1,
  class: "text-sm text-gray-400 text-center max-w-[320px]"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

import { computed, ref, watch } from "vue";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'TripTrackingQrTag',
  props: {
    payload: {},
    url: {},
    label: {},
    status: {}
  },
  setup(__props: any) {

	/**
	 * QR de suivi d'un trajet — à présenter au chauffeur.
	 *
	 * Le chauffeur le scanne avec l'app mobile : l'API ouvre alors une
	 * session GPS et le véhicule apparaît sur la carte flotte du web.
	 * Rien à saisir sur le téléphone, aucun jeton à recopier.
	 *
	 * Le payload vient de l'API (`tracking_qr_payload`) et est signé
	 * HMAC. L'API ne le renvoie que pour les trajets encore vivants :
	 * quand il est absent, on affiche pourquoi plutôt qu'un QR mort.
	 */
	const props = __props;

	const encoded = computed(() => props.url || props.payload || "");

	const dataUrl = ref<string>("");
	const error = ref<string>("");
	const isRendering = ref(false);

	async function render() {
		dataUrl.value = "";
		error.value = "";
		if (!encoded.value) return;

		isRendering.value = true;
		try {
			// Import dynamique : `qrcode` ne pèse dans le bundle que pour
			// ceux qui ouvrent réellement la modale.
			const qrcode = (await import("qrcode")).default;
			dataUrl.value = await qrcode.toDataURL(encoded.value, {
				width: 320,
				margin: 1,
				errorCorrectionLevel: "M",
			});
		} catch (e) {
			console.error(e);
			error.value = "Impossible de générer le QR.";
		} finally {
			isRendering.value = false;
		}
	}

	watch(encoded, render, { immediate: true });

	function printQr() {
		if (!dataUrl.value) return;
		const w = window.open("", "_blank", "width=420,height=560");
		if (!w) return;
		w.document.write(`
			<html><head><title>QR de suivi</title></head>
			<body style="font-family:sans-serif;text-align:center;padding:24px">
				<h3 style="margin:0 0 4px">Suivi du trajet</h3>
				<p style="margin:0 0 16px;color:#555">${props.label ?? ""}</p>
				<img src="${dataUrl.value}" style="width:280px;height:280px" />
				<p style="margin-top:16px;color:#555;font-size:12px">
					À scanner par le chauffeur avec l'application mobile
				</p>
			</body></html>
		`);
		w.document.close();
		w.focus();
		w.print();
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (encoded.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (isRendering.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Génération…"))
            : (dataUrl.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: dataUrl.value,
                  alt: "QR de suivi du trajet",
                  class: "w-[260px] h-[260px] bg-white p-2 rounded"
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true),
          (error.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(error.value), 1))
            : _createCommentVNode("", true),
          _hoisted_5,
          _createElementVNode("button", {
            type: "button",
            class: "px-4 py-2 rounded bg-[#219152] hover:bg-[#167841] text-white text-sm",
            disabled: !dataUrl.value,
            onClick: printQr
          }, " Imprimer ", 8, _hoisted_6)
        ], 64))
      : (_openBlock(), _createElementBlock("p", _hoisted_7, [
          _createTextVNode(" Aucun QR de suivi pour ce trajet. "),
          (_ctx.status === 'complete' || _ctx.status === 'cancelled')
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, " Le trajet est " + _toDisplayString(_ctx.status === 'complete' ? 'terminé' : 'annulé') + ". ", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_9, " Vérifiez qu'un véhicule lui est bien affecté. "))
        ]))
  ]))
}
}

})